import API from './API';
import { getParamsByOptions } from 'utils/functions';

const ProfileInvoiceAPI = {
	index: options => API.get('/user/invoices' + getParamsByOptions(options)),
	print: id => API.get(`/user/invoices/${id}/print`, { responseType: 'blob' }),
};

export default ProfileInvoiceAPI;
